// @ts-strict-ignore
import {StorageManager, StorageSetOptions} from './types';
import {validateKeyValue} from './util';

function stringifyKeyOrValue(keyOrValue: any): string {
  if (typeof keyOrValue === `undefined`) {
    return `undefined`;
  }
  if (keyOrValue === null) {
    return null;
  }
  return keyOrValue.toString();
}

// Stores items in-memory, useful for testing
export class DummyStorageManager implements StorageManager {
  private denyUnsafe = false;
  private storageListeners = new Set<() => any>();
  public items: Map<string, string> = new Map<string, string>();

  public constructor(denyUnsafe?: boolean) {
    this.denyUnsafe = !!denyUnsafe;
  }

  public setItem(key: string, value: string, options?: StorageSetOptions): Promise<boolean> | boolean {
    if (options?.unsafe) {
      if (this.denyUnsafe) {
        return false;
      }
    } else {
      validateKeyValue(key, value);
    }

    this.items.set(stringifyKeyOrValue(key), stringifyKeyOrValue(value));
    [...this.storageListeners].forEach((callback) => callback());
    return options?.unsafe ? true : Promise.resolve<boolean>(true);
  }

  public getItem(key: string): null | string {
    if (this.items.has(stringifyKeyOrValue(key))) {
      return stringifyKeyOrValue(this.items.get(key));
    }
    return null;
  }

  public addStorageEventListener(callback: () => any): void {
    this.storageListeners.add(callback);
  }

  public removeStorageEventListener(callback: () => any): void {
    this.storageListeners.delete(callback);
  }

  public removeItem(key: string): void {
    [...this.storageListeners].forEach((callback) => callback());
    this.items.delete(stringifyKeyOrValue(key));
  }
}
